import type { RowData } from "@tanstack/react-table";
import { Table } from "../../components/Table/Table";
import type { TableProps } from "../../components/Table/Table";

export type TanStackTableProps<T extends RowData> = Pick<
  TableProps<T>,
  | "columns"
  | "data"
  | "isPrinting"
  | "onRowClick"
  | "noResultsText"
  | "paginationLabel"
  | "gridClasses"
  | "clientPagination"
  | "roundedTop"
>;

export function TanStackTableSimple<T extends RowData>({
  columns,
  data,
  isPrinting,
  onRowClick,
  noResultsText,
  paginationLabel,
  gridClasses,
  clientPagination = true,
  roundedTop,
}: TanStackTableProps<T>) {
  return (
    <Table
      columns={columns}
      data={data}
      isPrinting={isPrinting}
      clientPagination={clientPagination}
      clientSort={true}
      gridClasses={gridClasses}
      onRowClick={onRowClick}
      noResultsText={noResultsText}
      paginationLabel={paginationLabel}
      roundedTop={roundedTop}
    />
  );
}
